import { render } from "./DeliveryDetailView.vue?vue&type=template&id=15032d9c&scoped=true"
import script from "./DeliveryDetailView.vue?vue&type=script&lang=js"
export * from "./DeliveryDetailView.vue?vue&type=script&lang=js"

import "./DeliveryDetailView.vue?vue&type=style&index=0&id=15032d9c&scoped=true&lang=css"
import "./DeliveryDetailView.vue?vue&type=style&index=1&id=15032d9c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15032d9c"]])

export default __exports__